import Vue from 'vue';
import Vuex from 'vuex';
import axios from "axios";
import players from '../modules/players/store';
import administrator from "../modules/administrator/store";
import translations from '../modules/translations/store';
import platformWallet from '../modules/platform-wallet/store';
import dashboardStore from '../modules/dashboard/store';
import userCampaign from '../modules/user-campaign/store/index';
import crmDashboardStore from '../modules/crm-dashboard/store';
import cms from '../modules/cms/store/index';
import userSegment from '../modules/user-segment/store/index';
import userNotification from '../modules/user-notification/store/index';
import scheduledTournament from '../modules/scheduled-tournaments-calendar/store/index';
import reports from '../modules/reports/store/index';
import statistics from '../modules/statistics/store/index';
import root from './root';
import modal from "@/store/modal";

Vue.prototype.$http = axios;
Vue.use(Vuex);
const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    modules: {
        root,
        players,
        administrator,
        translations,
        platformWallet,
        dashboardStore,
        crmDashboardStore,
        cms,
        userSegment,
        userCampaign,
        userNotification,
        scheduledTournament,
        reports,
        statistics,
        modal
    },
    strict: true,
    plugins: debug ? [] : []
});
